import React, { useEffect } from 'react';
import styled from 'styled-components';
interface Props {
  shown: boolean;
  scale: number;
  offset: { left: number; top: number };
  onClick(): void;
  onChange(offset: { left: number; top: number }): void;
}

const IMAGE_BODY_OFFSET = { left: 505, top: 290 };
const ZoomAreaBox = ({ shown, scale, offset, onClick, onChange }: Props) => {
  const _left = offset.left - IMAGE_BODY_OFFSET.left + window.scrollX;
  const _top = offset.top - IMAGE_BODY_OFFSET.top + window.scrollY;
  const _bound = {
    left: 343 - 40 * scale,
    top: 528 - 40 * scale
  };
  const _offset = {
    left: _left > 0 ? (_left > _bound.left ? _bound.left : _left) : 0,
    top: _top > 0 ? (_top > _bound.top ? _bound.top : _top) : 0
  };
  useEffect(() => {
    onChange(_offset);
  }, [offset]);
  return shown ? (
    <Wrapper
      onClick={() => onClick()}
      draggable={'true'}
      scale={scale}
      style={{
        left: `${_offset.left}px`,
        top: `${_offset.top}px`,
        zIndex: 999
      }}
    />
  ) : (
    <></>
  );
};

export default ZoomAreaBox;

const Wrapper = styled.div<{ scale?: number }>`
  position: absolute;
  ${({ scale = 2 }) => `
    width: ${40 * (scale + 2)}px;
    height: ${40 * (scale + 2)}px;
    `}
  top: 25rem;
  left: 300px;
  z-index: 9;

  background: rgba(255, 255, 255, 0.8);
  border: 1px solid #ff8d00;
  box-sizing: border-box;
`;
